import React from 'react';
import { Heading } from './Primitives';
import { CheckoutButton } from './CheckoutButton';
import { Guarantee } from './Guarantee';
import { CTA_LABEL } from '../data/content';
export function FinalCta() {
  return <section aria-label="Get started" className="relative overflow-hidden bg-orangey-700 px-5 py-14 sm:px-8 sm:py-[4.25rem]" data-id="element-38" data-mp="19g0cbghttsjd">
      <div aria-hidden="true" className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-orangey-500/40 blur-3xl" data-id="element-39" data-mp="15c2d75si4hqb" />
      <div className="relative mx-auto max-w-2xl text-center" data-id="element-40" data-mp="1eetqzc8unpl4">
        <Heading size="lg" className="!text-white" data-id="element-41" data-mp="1t2ydysexqn9p">
          Stop guessing. Start caring with confidence.
        </Heading>
        <p className="mt-4 text-lg text-orangey-100 sm:text-xl" data-id="element-42" data-mp="1o3bqlq5e7qn6">
          Your dog's personalized nutrition and care plan is less than a minute away.
        </p>
        <CheckoutButton variant="onDark" className="mt-7 w-full sm:w-auto" data-id="element-43" data-mp="221a12kglf2xe">
          {CTA_LABEL}
        </CheckoutButton>
        <Guarantee tone="onDark" className="mt-4" data-id="element-44" data-mp="n5ul3zmwvjfp" />
      </div>
    </section>;
}